import { fetchCollectionReq } from 'shared/api/axios';
import { IPagingData, MediaFilter, MediaInfoDto } from '@sr/dto';

export const fetchMediaDropdown = (paging: IPagingData,filterString: string = '') => {
  return fetchCollectionReq<MediaInfoDto>(
    `/media/dropdown?title=${filterString}`,
    MediaInfoDto,
  );
};

export const fetchMediaMatherDropdown = (id:number, filterString: string = '') => {
  return fetchCollectionReq<MediaInfoDto>(
    `/media/dropdown-mather/${id}?title=${filterString}`,
    MediaInfoDto,
  );
};